// This was made to prevent require cycle in the app
export { useFiltersContext as useFilters } from '~contexts'
